var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMeeting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1617006090996,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2033,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.032 176.064a16 16 0 0 1 16 16l-0.016 49.44h227.2a68.832 68.832 0 0 1 68.704 65.552l0.08 3.328v226.192c0 87.568-70.896 158.56-158.368 158.56l-112.688-0.016 111.152 100.224a16 16 0 0 1 1.152 22.624l-10.736 11.872a16 16 0 0 1-22.592 1.152l-103.904-93.712v94.608a16 16 0 0 1-16 16h-16.048a16 16 0 0 1-16-16V737.28l-103.888 93.712a16 16 0 0 1-21.152 0.256l-1.44-1.408-10.736-11.872v-0.016a16 16 0 0 1 1.152-22.608l111.136-100.224h-112.672c-85.984 0-155.952-68.592-158.304-154.112L192 536.576V310.384a68.832 68.832 0 0 1 68.8-68.864l227.168-0.016v-49.44a16 16 0 0 1 16-16h16.064zM763.2 289.568H260.784a20.8 20.8 0 0 0-20.8 20.816v226.192c0 61.024 49.424 110.512 110.384 110.512h323.264c60.96 0 110.384-49.488 110.384-110.512V310.384a20.8 20.8 0 0 0-20.8-20.816z m-100.976 89.344l1.488 1.344 0.016 0.016 11.2 11.44a16 16 0 0 1-0.192 22.608l-132.72 130.432a23.968 23.968 0 0 1-31.792 1.616l-1.808-1.6-59.712-58.592-65.92 64.224a16 16 0 0 1-22.656-0.32l-11.152-11.488a16 16 0 0 1 0.32-22.608l82.752-80.592a23.968 23.968 0 0 1 31.712-1.552l1.808 1.6 59.616 58.48 115.904-113.856a16 16 0 0 1 21.12-1.152z",
    "p-id": 2034
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeeting);
export default __webpack_public_path__ + "static/media/icon-meeting.cf2c788fae1757d63ee799f24fbc0faa.svg";
export { ForwardRef as ReactComponent };